<template>
  <div
    class="login_wrap flex flex_content_center flex_items_center"
    v-loading="loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="login_main">
      <div class="title">2025FDI 世界口腔医学大会-展览会</div>
      <div class="title">短信登录/注册</div>
      <div class="login_item">
        <el-input placeholder="请输入手机号" v-model="mobile" maxlength="11">
          <img
            class="icon"
            slot="prefix"
            src="../../assets/icon_m.png"
            alt=""
          />
        </el-input>
      </div>
      <div class="login_item">
        <vertifyPc
          v-if="isShowPC"
          @slide-verify="verifyType"
          :phone="mobile"
        ></vertifyPc>
        <vertifyMobile
          v-else
          @slide-verify="verifyType"
          :phone="mobile"
        ></vertifyMobile>
      </div>
      <div class="login_item">
        <el-input
          placeholder="请输入验证码"
          v-model="code"
          type="tel"
          autocomplete="one-time-code"
          maxlength="4"
          :disabled="!isShowCode"
        >
          <img
            class="icon"
            slot="prefix"
            style="width: 16px"
            src="../../assets/icon_v.png"
            alt=""
          />
        </el-input>
        <div class="code_wrap" :class="!isShowCode ? 'disabled_code' : ''">
          <div v-if="!isShowCountDown" @click="isShowCode ? getCode() : ''">
            获取验证码
          </div>
          <div v-else style="color: #666">{{ countNum }}s</div>
        </div>
      </div>
      <div class="login_text flex flex_items_center" @click="handleCheck">
        <img
          class="login_check"
          :src="
            isCheck
              ? require('../../assets/active_icon.png')
              : require('../../assets/defalut_icon.png')
          "
          alt=""
        />
        阅读协议并同意<span class="text" @click.stop="dialogVisible = true"
          >《用户协议与隐私政策》</span
        >
      </div>
      <div class="login_btn_wrap flex flex_content_sb">
        <div class="login_btn" @click="handleLogin">登录</div>
        <div class="login_btn btn_tourist" @click="touristLogin">游客访问</div>
      </div>
    </div>
    <el-dialog width="800px" :visible.sync="dialogVisible">
      <div v-html="privacyData.privacy_content"></div>
    </el-dialog>
  </div>
</template>
<script>
import { sendCode, login, getAgreement } from "@/api/api";
import vertifyPc from "./components/vertifyPc.vue";
import vertifyMobile from "./components/vertifyMoblie.vue";
export default {
  name: "login",
  components: {
    vertifyPc,
    vertifyMobile,
  },
  data() {
    return {
      mobile: "",
      code: "",
      isShowCode: false,
      isCheck: false,
      timer: null,
      privacyData: {},
      isShowCountDown: false,
      countNum: 60,
      dialogVisible: false,
      isShowPC: true,
      isVerified: false,
      loading: false,
    };
  },
  created() {},
  mounted() {
    //25.6.16  判断是否移动端 dxm
    this.isMobile();
    //25.6.13 获取隐私协议 dxm
    this.getAgreementData();
  },
  methods: {
    handleSuccess() {
      this.isVerified = true;
      this.$message.success("验证通过");
      // 提交表单等后续操作
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.isShowPC = false;
      } else {
        this.isShowPC = true;
      }
    },
    async getAgreementData() {
      const res = await getAgreement();
      this.privacyData = res.data;
    },
    handleCheck() {
      this.isCheck = !this.isCheck;
    },
    verifyType(data) {
      this.isShowCode = data;
    },
    //发送验证码
    getCode() {
      this.isShowCountDown = true;
      this.startCountdown();
      let data = this.$qs.stringify({
        mobile: this.mobile,
      });
      sendCode(data)
        .then((res) => {
          console.log(res);
          this.$message.success({
            message: res.msg,
            center: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    startCountdown() {
      this.isShowCountDown = true;
      this.timer = setInterval(() => {
        if (this.countNum <= 1) {
          clearInterval(this.timer);
          this.countNum = 60;
          this.isShowCountDown = false;
        } else {
          this.countNum--;
        }
      }, 1000);
    },
    //登录
    async handleLogin() {
      if (this.mobile == "") {
        this.$message.warning({
          message: "请输入手机号",
          center: true,
        });
        return;
      }
      if (this.code == "") {
        this.$message.warning({
          message: "请输入验证码",
          center: true,
        });
        return;
      }
      if (!this.isCheck) {
        this.$message.warning({
          message: "请勾选阅读协议并同意!",
          center: true,
        });
        return;
      }
      this.loading = true;
      let data = this.$qs.stringify({
        mobile: this.mobile,
        sms_code: this.code,
      });
      try {
        const res = await login(data);
        let loginRes = {
          token: res.data.token,
          isLogin: true,
        };
        this.$store.commit("userStatus", loginRes);
        localStorage.setItem("Flag", "isLogin");
        this.loading = false;
        //如果请求成功就让他1秒跳转路由
        setTimeout(() => {
          this.$router.push({
            path: "/",
          });
        }, 1000);
      } catch (error) {
        this.loading = false;
      }
    },
    //25.6.20 游客登录 dxm
    touristLogin() {
      localStorage.clear();
      this.$router.push({
        path: "/",
      });
      location.reload();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.login_wrap {
  width: 100vw;
  height: 100vh;
  position: relative;
  background: url("../../assets/login_bg.jpg") no-repeat;
  background-size: cover;
  .login_main {
    width: 400px;
    height: 431px;
    padding: 30px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
      0px 9px 28px 0px rgba(0, 0, 0, 0.05),
      0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 25px;
      padding-bottom: 10px;
    }
    .login_item {
      margin-top: 15px;
      position: relative;
      /deep/ .el-input__inner {
        height: 46px;
        line-height: 46px;
        padding-left: 44px;
        border-radius: 8px;
        border-color: #cad2dd;
      }
      /deep/ .el-input__prefix {
        left: 15px;
        display: flex;
        align-items: center;
      }
      .icon {
        width: 13px;
      }
      .code_wrap {
        position: absolute;
        top: 50%;
        right: 15px;
        cursor: pointer;
        font-size: 14px;
        color: #1677ff;
        z-index: 0;
        transform: translateY(-50%);
      }
      .disabled_code {
        color: #999;
        cursor: no-drop;
      }
    }
    .login_text {
      color: #555;
      font-size: 13px;
      cursor: pointer;
      line-height: 22px;
      padding-top: 10px;
      .login_check {
        width: 18px;
        height: 18px;
        margin-right: 7px;
      }
      .text {
        color: #1677ff;
      }
    }
    .login_btn_wrap {
      margin-top: 40px;
      .login_btn {
        width: 218px;
        height: 46px;
        color: #fff;
        font-size: 14px;
        line-height: 46px;
        cursor: pointer;
        text-align: center;
        background: #e62344;
        border-radius: 8px;
      }
      .btn_tourist {
        width: 112px;
        color: #999;
        background: #ece3e5;
      }
    }
  }
}
/deep/ .el-dialog__body {
  height: 600px;
  padding: 30px;
  overflow-y: scroll;
}
@media only screen and (max-width: 767px) {
  .login_wrap .login_main {
    width: 90%;
    height: auto;
    padding: 20px;
    margin-top: -2rem;
    .title {
      font-size: 0.31rem;
      line-height: 0.42rem;
      padding-bottom: 0.19rem;
    }
    .login_item {
      margin-top: 0.29rem;
    }
    .login_btn_wrap {
      flex-wrap: wrap;
      margin-top: 0.45rem;
      .login_btn {
        width: 100%;
      }
      .btn_tourist {
        margin-top: 10px;
      }
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
    .el-dialog__body {
      height: 60vh;
      padding: 0.4rem;
    }
  }
}
</style>